<div [ngClass]="['empty-state', size]">
  <div class="empty-state-icon">
    <i class="{{ iconString }}"></i>
  </div>

  <div class="empty-state-title">
    {{ title }}
  </div>

  <div class="empty-state-text" [innerHTML]="text">
    <!-- {{text}} -->
  </div>
</div>
